import React from 'react';
import ContactForm from '../../ui/ContactForm';
import styles from './ContactSection.module.css';

const ContactSection = () => {
  return (
    <section className={styles.contact}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h2 className={styles.title}>Contact Us</h2>
          <p className={styles.description}>
            Partnerships, press, or anything else — we'd love to hear from you.
          </p>
          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
